import { useEffect } from "react";
import type { RefObject } from "react";

/**
 * Publica a altura da topbar como `--altura-da-topbar` no quadro da casca. Só o CSS do console lê
 * a variável; no portal do cliente ela fica gravada sem uso.
 *
 * O menu lateral rola dentro do próprio espaço e precisa caber na tela abaixo da topbar enquanto
 * ela ainda está à vista. Sem isso, com a página no topo, o fim do menu ficava fora da tela e a
 * roda sobre o menu não chegava lá (SUS-15399). A topbar quebra linha conforme a largura e o que
 * mostra, e por isso a altura é medida, e não fixada no CSS.
 */
export function useAlturaDaTopbar(quadro: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    const elemento = quadro.current;
    const topbar = elemento?.querySelector<HTMLElement>(".topbar");
    if (!elemento || !topbar) return;

    const publicar = () =>
      elemento.style.setProperty("--altura-da-topbar", `${topbar.offsetHeight}px`);
    publicar();
    if (typeof ResizeObserver === "undefined") return;
    const observador = new ResizeObserver(publicar);
    observador.observe(topbar);
    return () => observador.disconnect();
  }, [quadro]);
}
